// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bfe1","toggleWrap":"styles_toggleWrap__3W0_u","content":"styles_content__1JBxq","selectAreaCode":"styles_selectAreaCode__2eJC_"};